import { VehicleSelectionMethod } from '../../enums';
const vinChanged = (state, action) => {
    //Vin should be saved even when vehicle is resolved with assisted select
    if (state.Vehicle && state.Vehicle.Value) {
        let value;
        let vehicleData;
        if (state.VehicleSelectionMethod === VehicleSelectionMethod.VinDecode) {
            value = {
                Id: -1,
                ServiceBarcode: '',
                Vin: action.payload.vin
            };
            vehicleData = Object.assign(Object.assign({}, state.Vehicle), { Value: value });
            return Object.assign(Object.assign(Object.assign({}, state), {
                Makes: [],
                Models: [],
                SubModels: [],
                BodyStyles: [],
                Engines: [],
                FuelType: [],
                Transmissions: [],
                DriveTrains: [],
                Types: [],
                Years: []
            }), { Vehicle: vehicleData, Vin: action.payload.vin });
        }
        value = Object.assign(Object.assign({}, state.Vehicle.Value), { Vin: action.payload.vin });
        vehicleData = Object.assign(Object.assign({}, state.Vehicle), { Value: value });
        return Object.assign(Object.assign({}, state), { Vehicle: vehicleData, Vin: action.payload.vin });
    }
    return Object.assign(Object.assign({}, state), { Vin: action.payload.vin });
};
export default vinChanged;
//# sourceMappingURL=vinChanged.js.map